<template>
    <div class="CheckBoxWithLabel">
        <div class="CheckBoxWithLabel-container">
            <input
                :id="'js-checkbox-' + inputId"
                :value="value"
                type="checkbox"
                :aria-label="ariaLabel || label"
                :aria-required="isRequired"
                tabindex="0"
                :checked="value"
                @input="optionChanged"
            >
            <label :for="'js-checkbox-' + inputId">
                {{ label }}
                <slot v-if="!label" />
                <span
                    v-if="isRequired"
                    class="CheckBoxWithLabel-required"
                >*</span>
            </label>
        </div>
        <div
            :id="'js-error-' + inputId"
            :aria-label="errorLabel"
            :tabindex="getErrorTabIndex"
            :class="{ 'CheckBoxWithLabel-error--displayed': errorLabel !== '' }"
            class="CheckBoxWithLabel-error"
        >
            {{ errorLabel }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            default: ''
        },
        ariaLabel: {
            type: String,
            default: ''
        },
        isRequired: {
            type: Boolean,
            default: false
        },
        errorLabel: {
            type: String,
            default: ''
        },
        value: {
            type: Boolean,
            default: false
        }

    },
    data: () => {
        return {
            inputId: null
        }
    },
    computed: {
        getErrorTabIndex () {
            return this.errorLabel !== '' ? '0' : '-1'
        },
    },
    watch: {
        errorLabel() {
            if (this.errorLabel !== '') {
                document.querySelector('#js-error-' + this.inputId).focus()
            }
        },
    },
    mounted() {
        this.inputId = this._uid;
    },
    methods: {
        optionChanged() {
            this.$emit('input', !this.value);
        }
    }
}

</script>

<style lang="scss" scoped>
.CheckBoxWithLabel {
    width: 100%;

    &-container {
        display: flex;
        gap: 10px;
        align-items: center;
    }

    input[type="checkbox"] {
        /* Add if not using autoprefixer */
        -webkit-appearance: none;
        appearance: none;
        /* For iOS < 15 to remove gradient background */
        background-color: #fff;
        /* Not removed via appearance */
        margin: 0;
        font: inherit;
        color: currentColor;
        min-width: 1.15em;
        min-height: 1.15em;
        width: 1.15em;
        height: 1.15em;
        border: 1px solid $color-f2m-pink;
        border-radius: 5px;
        transform: translateY(-0.075em);
        display: grid;
        place-content: center;
    }

    input[type="checkbox"]::before {
        content: "";
        width: 0.65em;
        height: 0.65em;
        background-color: $color-f2m-pink;
        transform: scale(0);
        transition: 120ms transform ease-in-out;
        box-shadow: inset 1em 1em white;
        transform-origin: bottom left;
        clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
    }

    input[type="checkbox"]:checked{
        background-color: $color-f2m-pink;
        border-color: $color-f2m-pink;
    }

    input[type="checkbox"]:checked::before {
        transform: scale(1);
    }

    &-required {
        color: $color-error;
    }

    &-error {
        margin-bottom: 0;
        opacity: 0;
        transition: all .3s ease-in-out;

        &--displayed {
            margin-top: 10px;
            opacity: 1;
        }
    }

    &-error--displayed {
        @include errorBlock;
    }


}
</style>
